import styled from 'styled-components';
import { Button } from 'antd';
import { colors } from '../../theme/colors';
import { breakpoints } from '../../theme/breakpoints';
import { fonts } from '../../theme/fonts';

export const LearnMoreContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  max-width: 1200px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    gap: 40px;
    padding: 60px 20px;
    margin: 40px auto;
  }
`;

export const ImageWrapper = styled.div`
  flex: 1;
  max-width: 500px;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
`;

export const LearnMoreImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 500px;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
    text-align: center;
  }
`;

export const Description = styled.p`
  color: ${colors.white};
  font-size: 18px;
  line-height: 1.6;
  margin: 0;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 16px;
  }
`;

export const StyledButton = styled(Button)`
  &.ant-btn {
    background-color: ${colors.primary};
    border: none;
    color: ${colors.white};
    font-family: ${fonts.families.primary};
    font-weight: 600;
    font-size: 16px;
    padding: 12px 40px;
    height: auto;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${colors.primaryDark} !important;
      color: ${colors.white} !important;
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }

    @media (max-width: ${breakpoints.tablet}) {
      width: 100%;
      max-width: 300px;
      margin: 0 auto;
    }
  }
`;
